<template>
  <div>
    <hospital-waiting-filter
      v-model="filter"
      @hospitals="hospitals = $event"
      @fetch="fetch"
    ></hospital-waiting-filter>
    <hospital-waiting-table
      :isLoading="isLoading"
      :list="list"
      @fetch="fetch"
    ></hospital-waiting-table>
  </div>
</template>

<script>
import recipientService from "../../assets/services/recipient.service";
import HospitalWaitingFilter from "../../components/waitingList/hospitalWaitingList/HospitalWaitingFilter.vue";
import HospitalWaitingTable from "../../components/waitingList/hospitalWaitingList/HospitalWaitingTable.vue";
export default {
  components: { HospitalWaitingTable, HospitalWaitingFilter },
  data() {
    return {
      isLoading: false,
      filter: {},
      list: [],
      hospitals: [],
    };
  },
  methods: {
    async fetch() {
      const vm = this;
      try {
        vm.isLoading = true;
        vm.list = [];
        let { data } = await recipientService.getHospitalWaitingList(
          vm.filter
        );
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (!status) {
          vm.$alert.show(msg);
          return;
        }
        vm.list = list;
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
